// node_modules
import {Dropdown} from 'primereact/dropdown'
import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {useMobile} from '../../../hooks/useMobile'
import {
	useCreateOrganizationMutation,
	useDeleteOrganizationMutation,
	useGetOrganizationListQuery,
	useLazyGetOrganizationNotificationOptionsQuery,
	useUpdateOrganizationMutation,
	useUpdateOrganizationNotificationOptionsMutation
} from '../../../redux/services/organization'

// redux
import { setLoading } from "../../../redux/slices/app.slice";

// primereact components
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

// context
import { ToastContext } from "../../../App";
import getSubdomain from '../../../utils/getSubdomain'

// styles
import * as styles from "./Notifications.module.css";

const Notifications = () => {
	const showToast = useContext(ToastContext);
	const dispatch = useDispatch();
	const {isMobile} = useMobile();
	
	const [selectedOrganization, setSelectedOrganization] = useState(null)
	
	const {data: organizations, isSuccess: isGetOrganizationsSuccess, isError: isGetOrganizationError} = useGetOrganizationListQuery();
	
	const [getOptions, {
		data: options,
		isSuccess: isGetOptionsSuccess,
		isLoading: isGetOptionsLoading,
		isError: isGetOptionsError
	}] = useLazyGetOrganizationNotificationOptionsQuery();
	const [updateOption, { isSuccess: isUpdateOptionSuccess, isError: isUpdateOptionError, error: updateOptionError }] =
		useUpdateOrganizationNotificationOptionsMutation();
	
	useEffect(() => {
		if(selectedOrganization) {
			getOptions(selectedOrganization.id)
		}
	}, [selectedOrganization])
	
	useEffect(() => {
		if(isGetOrganizationsSuccess) {
			dispatch(setLoading(false))
		}
	}, [isGetOrganizationsSuccess])
	
	useEffect(() => {
		if(isGetOrganizationError) {
			showToast('error', 'Organization', 'Unable to load organizations')
			dispatch(setLoading(false));
		}
	}, [isGetOrganizationError])
	
	useEffect(() => {
		if(isGetOptionsSuccess)
			dispatch(setLoading(false));
	}, [isGetOptionsSuccess])
	
	useEffect(() => {
		if(isGetOptionsError) {
			showToast('error', 'Organization Notifications', 'Unable to load organization notifications')
			dispatch(setLoading(false));
		}
	}, [isGetOptionsError])
	
	useEffect(() => {
		if(isUpdateOptionSuccess) {
			showToast('success', 'Organization Notifications', 'Notification updated!')
		}
	}, [isUpdateOptionSuccess])
	
	useEffect(() => {
		if(isUpdateOptionError) {
			showToast("error", updateOptionError?.status, updateOptionError?.data?.message || (updateOptionError?.data?.errors && "Incorrect data"))
		}
	}, [isUpdateOptionError])
	
	const actionBodyTemplate = (item) => {
		return (
			<div
				style={{ display: "flex", justifyContent: "center", flexShrink: 0, width: "175px" }}
			>
				{item.active ? (
					<Button
						icon="pi pi-eye"
						className={`p-button-text ${styles.activeBtn}`}
						size="large"
						onMouseUp={() => {
							updateOption({
								id: selectedOrganization.id,
								notificationId: item.id,
								active: false
							});
						}}
					/>
				) : (
					<Button
						icon="pi pi-eye-slash"
						className={`p-button-text ${styles.activeBtn}`}
						size="large"
						onMouseUp={() => {
							updateOption({
								id: selectedOrganization.id,
								notificationId: item.id,
								active: true
							});
						}}
					/>
				)}
			</div>
		);
	};
	
	return (
		<div className={styles.pageWrapper}>
			<div className={styles.header}>
				{isGetOrganizationsSuccess && (
					<>
						<Dropdown
							value={selectedOrganization}
							onChange={(e) => setSelectedOrganization(e.value)}
							options={organizations?.toSorted((a, b) =>
								a.name.localeCompare(b.name)
							)}
							optionLabel="name"
							placeholder="Select organization"
							className={`${styles.dropdown}`}
						/>
					</>
				)}
				<div
					className={`flex align-items-center ${styles.headerTitle}`}
				>
					<h2>Notification Options</h2>
					{selectedOrganization && (
						<span className={styles.organizationLabel}>{selectedOrganization.name}</span>
					)}
				</div>
			</div>
			{selectedOrganization ? (
				<>
					{options && (
						isMobile ? (
							<div className={styles.cardList}>
								{options.map((option) => (
									<div key={option.title} className={styles.cardItem}>
										<div className={styles.cardInfo}>
											<div className={`${styles.name} capitalize`}>{option.title}</div>
										</div>
										<div className={styles.actions}>
											{option.active ? (
													<button className={styles.cardEditBtn} onClick={() => {
														updateOption({
															id: selectedOrganization.id,
															notificationId: option.id,
															active: false
														});
													}}>
														<i className="pi pi-eye" />
													</button>
											) : (
												<button className={styles.cardEditBtn} onClick={()=> {
													updateOption({
														id: selectedOrganization.id,
														notificationId: option.id,
														active: true
													});
												}}>
													<i className="pi pi-eye-slash" />
												</button>
											)}
										</div>
									</div>
								))}
							</div>
						) : (
							<DataTable value={options} rows={6} loading={isGetOptionsLoading}>
								<Column
									field="title"
									header="Title"
									body={(rowData) => {
										return <div className={styles.cellInsider}>{rowData.title.slice(0, 1).toUpperCase()+rowData.title.slice(1)}</div>;
									}}
								/>
								
								<Column
									body={actionBodyTemplate}
									header="Active"
									style={{ width: "175px" }}
								/>
							</DataTable>
						)
					)}
				</>
			) : (
				<div>Please select organization</div>
			)}
		</div>
	);
};

export default Notifications;
